import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow, FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { ProductSummaryList as ProductSummaryListComponent } from '../../../../vtex-apps/product-summary/ProductSummaryList/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function ProductSummaryList() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'ProductSummaryList',
		props: VisibilityLayout({ mzTitle: 'MZ | Vitrine (On/Off)' }).props,
		variables,
		childrenComponents: [
			FlexLayoutRow({ blockClass: 'shelf__product-list-2', colGap: 2, mzTitle: 'MZ | Vitrine' }, [
				FlexLayoutCol(
					{
						blockClass: 'product-list__flex-col-2',
					},
					[
						RichText({
							mzTitle: 'MZ | Título',
							textAlignment: 'CENTER',
							textPosition: 'CENTER',
							text: '## Acabaram de chegar',
							blockClass: 'product-list__title-2',
						}),
						ProductSummaryListComponent(
							{ blockClass: 'summary__list-2' },
							[
								SliderLayout({
									blockClass: 'summary__slider-layout-2',
									itemsPerPage: {
										desktop: 4,
										tablet: 2,
									},
								}),
							],
							[
								{
									componentGroup: 'ProductSummaryShelf',
									componentName: 'ProductSummaryShelfComponent',
									componentId: uuidv4(),
								},
							],
						),
					],
				),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--psl-2-background', name: 'background' },
			{ from: '--brand-color-primary-pure', to: '--psl-2-slider-color', name: 'Slider' },
			{ from: '--white', to: '--psl-2-arrow-color', name: 'Arrow' },
			{ from: '--white', to: '--psl-2-dots-color', name: 'Dots' },
			{ from: '--brand-color-primary-pure', to: '--psl-2-heading-color', name: 'Heading' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--psl-2-slider-br', name: 'Slider' },
			{ from: '--border-radius-sm', to: '--psl-2-dot-br', name: 'Dots' },
		],
	},
	{
		type: 'fontSize',
		list: [{ from: '--font-size-xxl', to: '--psl-2-heading-fs', name: 'Heading' }],
	},
	{
		type: 'fontWeight',
		list: [{ from: '--font-weight-700', to: '--psl-2-heading-fw', name: 'Heading' }],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--psl-2-ff', name: 'Heading' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: 0, to: '--psl-2-x-padding', name: 'Padding Lateral' },
			{ from: '--spacing-xxs', to: '--psl-2-dot-width', name: 'Dot Width' },
			{ from: '--spacing-xxs', to: '--psl-2-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--psl-2-dot-height', name: 'Dot Height' },
			{ from: '--spacing-nano', to: '--psl-2-dot-height-active', name: 'Dot Height Active' },
			{ from: '--spacing-md', to: '--psl-2-slider-btn', name: 'Slider Buttons' },
		],
	},
];
